import {findListByCustomerAndSku, initPage, orderSubmit,uploadUrl,uploadOrder,templateOrder,uploadOrderResult} from './../api';
import {findConsigneesByCustomerCode, findAddrsByConsigneeCode, findValidAddrsByCustomerCodeAndConsigneeCode,
  findValidAddrsByCustomerCode, findOrderTypesByCustomerCodeForPageCreateOrder, selectMinqtyByCustomerno} from '../../../../api'
const create = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    submitDataObj: null,
    consigneesObj: null,
    consigneecAddrsObj: null,
    ordertypesObj: null,
    uploadUrlObj: null,
    uploadOrderResp:null,
    templateOrderObj:null,
    uploadOrderResultObj:null,
    selectMinqtyByCustomernoData: null
  },
  mutations: {

    SEARCH_SKU(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    FIND_CONSIGNEES_BY_CUSTOMERCODE_DATA(state,data){
      state.consigneesObj = data.obj || {};
    },
    SUBMIT_DATA(state,data){
      state.submitDataObj = data || {};
    },
    FIND_ADDRS_BY_CONSIGNEECODE_DATA(state,data){
      state.consigneecAddrsObj = data.obj || {};
    },
    FIND_VALID_ADDRS_BY_CUSTOMERCODE_AND_CONSIGNEECODE(state,data){
      state.consigneecAddrsObj = data.obj || {};
    },
    FIND_VALID_ADDRS_BY_CUSTOMERCODE(state,data){
      state.consigneecAddrsObj = data.obj || {};
    },
    FIND_ORDERTYPES_BY_CUSTOMERCODE_DATA(state,data){
      state.ordertypesObj = data.obj || {};
    },
    UPLOAD_URL_DATA(state, data){
      state.uploadUrlObj = data || '';
    },
    UPLOAD_ORDERDATA(state, data) {
      state.uploadOrderResp = data;
    },
    DOWNLOAD_ORDERTEMPLATE(state, data) {
      state.templateOrderObj = data;
    },
    UPLOAD_ORDER__RESULT(state, data) {
      state.uploadOrderResultObj = data;
    },
    SELECT_MINQTY_DATA(state, data) {
      state.selectMinqtyByCustomernoData = data.obj || 0;
    },
  },
  actions: {
    //查询事件
    async findListByCustomerAndSku({commit}, obj){
      let resp = await findListByCustomerAndSku(obj);
      commit('SEARCH_SKU', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //提交
    async orderSubmit({commit}, obj){
      let resp = await orderSubmit(obj);
      commit('SUBMIT_DATA', resp);
    },
    async findConsigneesByCustomerCode({commit}, obj){
      let resp = await findConsigneesByCustomerCode(obj);
      commit('FIND_CONSIGNEES_BY_CUSTOMERCODE_DATA', resp);
    },
    async findAddrsByConsigneeCode({commit}, obj){
      let resp = await findAddrsByConsigneeCode(obj);
      commit('FIND_ADDRS_BY_CONSIGNEECODE_DATA', resp);
    },
    async findValidAddrsByCustomerCodeAndConsigneeCode({commit}, customerCode, consigneeCode){
      let resp = await findValidAddrsByCustomerCodeAndConsigneeCode(customerCode, consigneeCode);
      commit('FIND_VALID_ADDRS_BY_CUSTOMERCODE_AND_CONSIGNEECODE', resp);
    },
    async findValidAddrsByCustomerCode({commit}, customerCode, consigneeCode){
      let resp = await findValidAddrsByCustomerCode(customerCode, consigneeCode);
      commit('FIND_VALID_ADDRS_BY_CUSTOMERCODE', resp);
    },
    async findOrderTypesByCustomerCode({commit}, obj){
      let resp = await findOrderTypesByCustomerCodeForPageCreateOrder(obj);
      commit('FIND_ORDERTYPES_BY_CUSTOMERCODE_DATA', resp);
    },
    //文件上传路径
    async uploadUrl({ commit }, obj) {
      let resp = await uploadUrl(obj);
      commit('UPLOAD_URL_DATA', resp);
    },
    //导入订单数据
    async uploadOrder({ commit }, obj) {
      let resp = await uploadOrder(obj);
      commit('UPLOAD_ORDERDATA', resp);
    },
    //下载订单模板
    async templateOrder({ commit }, obj) {
      let resp = await templateOrder(obj);
      commit('DOWNLOAD_ORDERTEMPLATE', resp);
    },
    //导入导出结果
    async uploadOrderResult({ commit }, obj) {
      let resp = await uploadOrderResult(obj);
      commit('UPLOAD_ORDER__RESULT', resp);
    },
    //导入导出结果
    async selectMinqtyByCustomerno({ commit }, obj) {
      let resp = await selectMinqtyByCustomerno(obj);
      commit('SELECT_MINQTY_DATA', resp);
    },
  }
}
export default create



// WEBPACK FOOTER //
// ./src/page/recovery/create/store/recoveryCreate.store.js